import React, { useState, useEffect } from 'react'
import {
    Box,
    Card,
    Grid,
    Toolbar,
    IconButton,
    LinearProgress,
    Button,
    Modal,
    Fab,
    Popover,
    Checkbox,
    Divider,
    Hidden,
    CircularProgress
} from '@mui/material'
import { ArrowBackIos, Close } from '@mui/icons-material'
import { styleModal3D } from '../../config'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { MVAvatar, PautaDetail } from '../../containers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFilter,
    faBars,
    faFolder,
    faBook
} from '@fortawesome/free-solid-svg-icons'
import {
    useAuth,
    useConnectionContext,
    useExecutionReportContext,
    useReportsContext,
    useUser
} from '../../context'
import { ConfirmarDialog, PDFFileDialog, PreviewDialog, SpmDocumentsDialog } from '../../dialogs'
import { MenuActividades } from './MenuActividades'
import { MenuDocumentos } from './MenuDocumentos'
import { pdfMakeRoutes, reportsRoutes } from '../../routes'

const ActivitiesDetailPage = () => {
    const { userData } = useAuth()
    const {
        isOperator,
        admin,
        isSuperAdmin,
        isSapExecutive,
        isOperatorInspector,
        isUniversalInspector,
        isUniversalChief
    } = useUser()
    const { isOnline } = useConnectionContext()
    const params = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const {
        executionReport,
        setExecutionReport,
        messageOnReport,
        ejecucionActualizada,
        resultThisItemProgress,
        openMenu,
        setOpenMenu,
        ejecucion,
        setEjecucion,
        openPreviewModal,
        setOpenPreviewModal,
        getExecutionReport,
        setIsTermJornada,
        setOpenReportCommitModal,
        loadingImages
    } = useExecutionReportContext()
    const {
        guardarContadorEnReporte,
        pautas,
        otIndex,
        setOtIndex,
        report,
        setReport,
        getReports,
        progress,
        setProgress,
        pageProgress,
        setPageProgress,
        elevarReporte,
        priorityAssignments,
        waitReports,
        assignmentsLoaded,
        updateLocalReport
    } = useReportsContext()
    const [smActivated, setSmActivated] = useState(false)
    const [subSistem, setSubSistem] = useState()
    const [open3D, setOpen3D] = useState(false)
    const [ultimoGuardadoDispositivo, setUltimoGuardadoDispositivo] = useState()
    const [paginaOcultada, guardarPaginaOcultada] = useState(false)
    const [soloUnEnvio, setSoloUnEnvio] = useState(true)
    const [filterData, setFilterData] = useState({
        todo: true,
        sinAccion: true,
        sinEjecutar: true,
        ejecutado: true,
        backlogList: false
    })
    const [executionReportFiltered, setExecutionReportFiltered] = useState()
    const [documents, setDocuments] = useState([])
    const [openMenuDocumentos, setOpenMenuDocumentos] = useState(false)
    const [canEdit, setCanEdit] = useState(false)
    const [openPdfDialog, setOpenPdfDialog] = useState(false)
    const [fileSelected, setFileSelected] = useState(null)
    const [openConfirmarBack, setOpenConfirmarBack] = useState(false)
    const [openSpmDialog, setOpenSpmDialog] = useState(false)

    const handleTechnicalDocClick = () => {
        if (!report || !report.idPm) {
            alert('Esta orden no cuenta con un código SPM configurado.')
            return
        }
        setOpenSpmDialog(true)
    }

    const currentUserId = userData?._id
    const userHasStarted = report?.ejecuciones?.some(
        (e) =>
            (e.userId?._id || e.userId)?.toString() === currentUserId?.toString() &&
			e.termino === null
    )

    const handleBackWithConfirmation = () => {
        const isAnyOperator =
			isOperator ||
			isOperatorInspector ||
			isUniversalInspector
        if (
            isAnyOperator &&
			userHasStarted &&
			['En proceso', 'Reasignar', 'Ejecutando por operador'].includes(
			    report?.state || report?.estado
			)
        ) {
            setOpenConfirmarBack(true)
        } else {
            guardarContador(true)
        }
    }

    const onConfirmBackEndShift = () => {
        setOpenConfirmarBack(false)
        setIsTermJornada(true)
        setOpenReportCommitModal(true)
    }

    const onCancelBackNoEndShift = () => {
        setOpenConfirmarBack(false)
        guardarContador(true)
    }

    useEffect(() => {
        return () => {
            setReport(undefined)
            setExecutionReport(undefined)
        }
    }, [setReport, setExecutionReport])

    useEffect(() => {
        const isPureOperator =
			isOperator &&
			!admin &&
			!isSuperAdmin &&
			!isSapExecutive &&
			!isOperatorInspector &&
			!isUniversalInspector &&
			!isUniversalChief

        if (!report || !params.id || !isPureOperator) {
            return
        }

        const reportIdentifier = String(report.newIdIndex || report.idIndex)
        if (reportIdentifier !== String(params.id)) {
            return
        }

        const isUserAssignedInDetailedReport =
			report.usersAssigned &&
			Array.isArray(report.usersAssigned) &&
			report.usersAssigned.some(
			    (user) => String(user._id || user) === String(userData._id)
			)

        if ((waitReports || !assignmentsLoaded) && isUserAssignedInDetailedReport) {
            return
        }

        const isReportInUserAssignments = priorityAssignments.some(
            (assignedReport) =>
                String(assignedReport.newIdIndex || assignedReport.idIndex) ===
				String(params.id)
        )

        console.log('[ActivitiesDetail] Permission check for Pure Operator:', {
            isReportInUserAssignments,
            id: params.id
        })

        if (!isReportInUserAssignments) {
            navigate('/no-permission', {
                replace: true,
                state: {
                    error: {
                        title: 'Acceso Denegado al Reporte',
                        message:
							'Ya no tiene acceso a este reporte. Es posible que la tarea haya sido completada, reasignada o que su sesión haya cambiado.'
                    },
                    returnPath: '/activities'
                }
            })
        }
    }, [
        report,
        priorityAssignments,
        params.id,
        navigate,
        isOperator,
        admin,
        isSuperAdmin,
        isSapExecutive,
        isOperatorInspector,
        isUniversalInspector,
        isUniversalChief,
        waitReports,
        assignmentsLoaded,
        userData
    ])

    useEffect(() => {
        if (report && userData) {
            const isReportActive = report.level < 4
            const isUserAssigned =
				report.usersAssigned &&
				Array.isArray(report.usersAssigned) &&
				report.usersAssigned.some(
				    (user) => String(user._id || user) === String(userData._id)
				)

            // Universal Roles permission logic
            const currentUserId = userData?._id
            const userHasStartedInReport = report?.ejecuciones?.some(
                (e) =>
                    (e.userId?._id || e.userId)?.toString() ===
						currentUserId?.toString() && e.termino === null
            )
            const isExecutionInProgress = executionReport?.status === 'En proceso'
            const userHasStarted = userHasStartedInReport || isExecutionInProgress

            const isUniversalInspectorAccess =
				isUniversalInspector &&
				report.reportType === 'Inspección' &&
				(!report.level || report.level === 0) &&
				userHasStarted
            const isUniversalChiefAccess =
				isUniversalChief &&
				report.reportType === 'Inspección' &&
				report.level === 1 &&
				userHasStarted

            // Todos los operadores (normales y universales) DEBEN haber iniciado la OT para editar
            const operatorCanEdit =
				(isOperator || isOperatorInspector) &&
				isUserAssigned &&
				isReportActive &&
				userHasStarted

            setCanEdit(
                admin ||
					isSuperAdmin ||
					operatorCanEdit ||
					isUniversalInspectorAccess ||
					isUniversalChiefAccess
            )
        }
    }, [
        report,
        userData,
        admin,
        isSuperAdmin,
        isOperator,
        isOperatorInspector,
        isUniversalInspector,
        isUniversalChief,
        executionReport
    ])

    useEffect(() => {
        const currentOtIndex = params.id
        if (!currentOtIndex) return

        setOtIndex(currentOtIndex)

        const isReportLoaded =
			report &&
			String(report.newIdIndex || report.idIndex) === String(currentOtIndex)
        const executionReportId =
			executionReport?.report?._id || executionReport?.report
        const isExecutionLoaded =
			executionReport &&
			report &&
			String(executionReportId) === String(report._id)

        if (isReportLoaded && isExecutionLoaded) {
            return
        }

        getExecutionReport(currentOtIndex)
    }, [params.id, getExecutionReport, setOtIndex])

    useEffect(() => {
        if (ejecucionActualizada) {
            if (ejecucion.inicio) {
                guardarContadorSelect(false)
            }
        }
    }, [ejecucionActualizada])

    useEffect(() => {
        if (report && pautas.length > 0) {
            console.log(pautas)
            console.log(report)
            const pauta = pautas.filter(
                (p) => report.idPm === p.idpm && report.guide === p.typepm
            )
            console.log(pauta)
            if (pauta.length > 0 && pauta[0] && pauta[0].docs) {
                setDocuments(pauta[0].docs)
            } else {
                setDocuments([])
            }
        }
    }, [pautas, report])

    const guardarContadorSelect = async (state) => {
        await guardarContador(state)
    }

    useEffect(() => {
        if (!soloUnEnvio) {
            setTimeout(() => {
                setSoloUnEnvio(true)
            }, 5000)
        }
    }, [soloUnEnvio])

    const filtering = async () => {
        console.log(executionReport)
        const executionReportFilteredCache = executionReport
        const group = {}
        if (executionReport && executionReport.group) {
            Object.keys(executionReport.group).forEach(async (key) => {
                if (!group[key]) {
                    group[key] = []
                }
                executionReport.group[key].forEach((item) => {
                    if (filterData.todo) {
                        group[key].push(item)
                    } else if (filterData.backlogList) {
                        if (item && item.backlogList && item.backlogList.length > 0) {
                            group[key].push(item)
                        }
                    }
                })
            })
        }
        executionReportFilteredCache.group = group
        setExecutionReportFiltered(executionReportFilteredCache)
    }

    useEffect(() => {
        if (userData && report) {
            const hasActiveExecution = report.ejecuciones?.some(
                (e) =>
                    (e.userId?._id || e.userId)?.toString() === userData._id &&
					e.termino === null
            )

            if (hasActiveExecution) {
                const visibilityHandler = async () => {
                    if (document.hidden) {
                        await guardarContador(false)
                        guardarPaginaOcultada(true)
                    } else {
                        if (paginaOcultada) {
                            const now = new Date()
                            const currentEjecucion = report.ejecuciones.find(
                                (e) =>
                                    (e.userId?._id || e.userId)?.toString() ===
										userData._id && e.termino === null
                            )
                            if (currentEjecucion) {
                                setEjecucion({
                                    ...currentEjecucion,
                                    inicio: now
                                })
                            }
                            guardarPaginaOcultada(false)
                        }
                    }
                }

                document.addEventListener('visibilitychange', visibilityHandler, false)
                return () =>
                    document.removeEventListener('visibilitychange', visibilityHandler)
            }
        }
    }, [report, userData, paginaOcultada])

    const getPautaProgreso = ({ progressPage, globalProgress }) => {
        setPageProgress(Number(progressPage))
        setProgress(Number(globalProgress))
    }

    const guardarContador = (nav) => {
        console.log(nav)
        return new Promise((resolve) => {
            const ejecucionCache = { ...ejecucion }
            if (ejecucionCache.inicio) {
                ejecucionCache.termino = new Date()
                if (report) {
                    const updatedEjecuciones = [...(report.ejecuciones || [])]
                    const res = updatedEjecuciones.findIndex(
                        (item) =>
                            new Date(item.inicio).getTime() ===
							new Date(ejecucionCache.inicio).getTime()
                    )

                    if (res === -1) {
                        updatedEjecuciones.push(ejecucionCache)
                    } else {
                        updatedEjecuciones[res] = ejecucionCache
                    }

                    // Persist locally
                    updateLocalReport(report._id, { ejecuciones: updatedEjecuciones })
                }
            }
            if (nav) {
                if (location.state?.from === 'reports') {
                    navigate('/reports')
                } else {
                    navigate(-1)
                }
                setEjecucion({
                    inicio: null,
                    termino: null,
                    userId: null
                })
            }
            resolve(true)
        })
    }

    const closeModal = () => {
        setOpen3D(false)
    }

    // Helper to prevent PDF caching issues
    const cacheBustUrl = (url) => {
        if (!url) return ''
        const separator = url.includes('?') ? '&' : '?'
        return `${url}${separator}cb=${new Date().getTime()}`
    }

    const handleGeneratePdf = async () => {
        if (!report || !report._id) {
            alert('No hay reporte disponible para generar el PDF.')
            return
        }

        try {
            const payload = {
                reportData: {
                    _id: report._id
                }
            }
            const createPdfResponse = await pdfMakeRoutes.createPdfDoc(payload)
            const sasUrl = createPdfResponse.data?.url
            if (sasUrl) {
                setFileSelected(cacheBustUrl(sasUrl))
                setOpenPdfDialog(true)
                getReports()
            } else {
                alert(
                    'No se pudo obtener la URL del PDF (SAS) después de la generación. Intente de nuevo.'
                )
            }
        } catch (error) {
            console.error(
                'Error generating PDF:',
                error.response || error.message || error
            )
            alert('Ocurrió un error al generar el PDF.')
        } finally {
        }
    }

    const downloadFile = async (url, filename) => {
        try {
            const response = await fetch(url)
            if (!response.ok) throw new Error('Network response was not ok')
            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } catch (error) {
            console.error('Download failed:', error)
        }
    }

    const handleApproveAndClose = async () => {
        if (!report) {
            alert('No hay reporte para cerrar.')
            return
        }

        if (report.progress !== 100) {
            alert('El reporte no está al 100% de progreso.')
            return
        }

        if (
            !confirm(
                `¿Está seguro de aprobar y cerrar el reporte OT ${otIndex}? Esta acción es irreversible.`
            )
        ) {
            return
        }

        try {
            const reportToUpdate = {
                _id: report._id,
                state: 'Completadas',
                level: 4,
                endReport: new Date(),
                emailing: 'termino-orden-4',
                fullNameWorker: `${userData.name} ${userData.lastName}`
            }

            if (isSapExecutive) {
                reportToUpdate.sapExecutiveApprovedBy = userData._id
                reportToUpdate.sapExecutiveApprovedDate = new Date()
            } else {
                reportToUpdate.chiefMachineryApprovedBy = userData._id
                reportToUpdate.chiefMachineryApprovedDate = new Date()
            }

            await elevarReporte(reportToUpdate)

            // Generate PDF
            const pdfPayload = {
                reportData: {
                    _id: report._id
                }
            }
            const createPdfResponse = await pdfMakeRoutes.createPdfDoc(pdfPayload)
            const sasUrl = createPdfResponse.data?.url

            if (sasUrl) {
                // Download PDF
                const filename = `OT_${otIndex}_${report.idPm || 'Reporte'}.pdf`
                await downloadFile(sasUrl, filename)
            } else {
                console.warn('No URL returned for PDF, skipping download.')
            }

            alert('Reporte aprobado y cerrado exitosamente.')
            await getReports()
            navigate('/reports')
        } catch (error) {
            console.error(
                'Error approving and closing report:',
                error.response ? error.response.data : error.message || error
            )
            alert('Ocurrió un error al intentar aprobar y cerrar el reporte.')
        } finally {
        }
    }

    const closePreviewModal = () => {
        setOpenPreviewModal(false)
    }

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const idPopover = open ? 'simple-popover' : undefined

    const executeFilter = (filter) => {
        setFilterData(filter)
    }

    const SelectionPopover = () => {
        const [todo, setTodo] = useState(true)
        const [sinAccion, setSinAccion] = useState(true)
        const [sinEjecutar, setSinEjecutar] = useState(true)
        const [ejecutado, setEjecutado] = useState(true)
        const [backlogList, setBacklogList] = useState(false)

        useEffect(() => {
            setTodo(filterData.todo)
            setSinAccion(filterData.sinAccion)
            setSinEjecutar(filterData.sinEjecutar)
            setEjecutado(filterData.ejecutado)
            setBacklogList(filterData.backlogList)
        }, [filterData])

        useEffect(() => {
            if (!sinAccion || !sinEjecutar || !ejecutado) {
                setTodo(false)
            }
            if (sinAccion && sinEjecutar && ejecutado) {
                if (!filterData.backlogList) {
                    setTodo(true)
                }
                setBacklogList(filterData.backlogList)
            }
        }, [sinAccion, sinEjecutar, ejecutado])

        useEffect(() => {
            if (todo) {
                if (!sinAccion) {
                    setSinAccion(true)
                }
                if (!sinEjecutar) {
                    setSinEjecutar(true)
                }
                if (!ejecutado) {
                    setEjecutado(true)
                }
                if (backlogList) {
                    setBacklogList(false)
                }
            }
        }, [todo])

        useEffect(() => {
            if (backlogList) {
                if (todo) {
                    setTodo(false)
                }
            }
        }, [backlogList])

        const setFilter = () => {
            const data = {
                todo: todo,
                sinAccion: sinAccion,
                sinEjecutar: sinEjecutar,
                ejecutado: ejecutado,
                backlogList: backlogList
            }
            executeFilter(data)
            handleClose()
        }

        return (
            <Popover
                id={idPopover}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
            >
                <div style={{ width: 200 }}>
                    <p>
                        <Checkbox
                            checked={todo}
                            onChange={(e) => setTodo(e.target.checked)}
                        />{' '}
						Todo
                    </p>
                    <p>
                        <Checkbox
                            checked={sinAccion}
                            onChange={(e) => setSinAccion(e.target.checked)}
                        />{' '}
						Sin acciones
                    </p>
                    <p>
                        <Checkbox
                            checked={sinEjecutar}
                            onChange={(e) => setSinEjecutar(e.target.checked)}
                        />{' '}
						Sin ejecutar
                    </p>
                    <p>
                        <Checkbox
                            checked={ejecutado}
                            onChange={(e) => setEjecutado(e.target.checked)}
                        />{' '}
						Ejecutados
                    </p>
                    <Divider />
                    <p>
                        <Checkbox
                            checked={backlogList}
                            onChange={(e) => setBacklogList(e.target.checked)}
                        />{' '}
						Hallazgo
                    </p>
                    <Divider />
                    <div style={{ textAlign: 'center', margin: '10px 0px' }}>
                        <Button variant={'contained'} onClick={setFilter}>
							Filtrar
                        </Button>
                    </div>
                </div>
            </Popover>
        )
    }

    const openButtonMenuDocumentos = () => {
        setOpenMenuDocumentos(true)
    }

    return (
        <Box height="80vh">
            <MenuActividades
                openMenu={openMenu}
                setOpenMenu={setOpenMenu}
                id={otIndex}
                report={report}
                setOpen3D={setOpen3D}
            />
            <MenuDocumentos
                openMenu={openMenuDocumentos}
                setOpenMenu={setOpenMenuDocumentos}
                documents={documents}
            />
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={'pageCard'}>
                        <Grid container alignItems="center" justifyContent="center">
                            <div style={{ width: '100%', textAlign: 'left', padding: 10 }}>
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                        color: '#333',
                                        backgroundColor: '#fff',
                                        borderRadius: 20
                                    }}
                                >
                                    <Toolbar
                                        style={{
                                            paddingLeft: 0,
                                            backgroundColor: '#F9F9F9',
                                            borderRadius: 10,
                                            width: '100%',
                                            position: 'relative'
                                        }}
                                    >
                                        <IconButton onClick={handleBackWithConfirmation}>
                                            <ArrowBackIos style={{ color: '#333', fontSize: 16 }} />
                                        </IconButton>
                                        <Hidden mdDown>
                                            <h1
                                                style={{ marginTop: 0, marginBottom: 0, fontSize: 16 }}
                                            >
												Actividades Asignadas / Detalle / OT {otIndex}{' '}
                                                <strong>
                                                    {report && report.testMode ? 'Modo test' : ''}
                                                </strong>
                                            </h1>
                                        </Hidden>
                                        <Hidden mdUp>
                                            <h1
                                                style={{ marginTop: 0, marginBottom: 0, fontSize: 16 }}
                                            >
												OT {otIndex}{' '}
                                                <strong>
                                                    {report && report.testMode ? 'Modo test' : ''}
                                                </strong>
                                            </h1>
                                        </Hidden>
                                        {loadingImages && (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                    ml: 2,
                                                    color: 'text.secondary',
                                                    fontSize: '0.875rem'
                                                }}
                                            >
                                                <CircularProgress size={16} />
                                                <span>Sincronizando fotos...</span>
                                            </Box>
                                        )}
                                        <IconButton
                                            style={{ position: 'absolute', right: 110 }}
                                            color={'primary'}
                                            edge={'end'}
                                            title="Documentación Técnica"
                                            onClick={handleTechnicalDocClick}
                                        >
                                            <FontAwesomeIcon style={{ zIndex: 10 }} icon={faBook} />
                                        </IconButton>
                                        <IconButton
                                            style={{ position: 'absolute', right: 70 }}
                                            color={'primary'}
                                            edge={'end'}
                                            title="Filtrar"
                                            aria-describedby={idPopover}
                                            onClick={handleClick}
                                        >
                                            <FontAwesomeIcon style={{ zIndex: 10 }} icon={faFilter} />
                                        </IconButton>
                                        <IconButton
                                            style={{ position: 'absolute', right: 30 }}
                                            color={'primary'}
                                            edge={'end'}
                                            title="Filtrar"
                                            aria-describedby={idPopover}
                                            onClick={() => {
                                                setOpenMenu(true)
                                            }}
                                        >
                                            <FontAwesomeIcon style={{ zIndex: 10 }} icon={faBars} />
                                        </IconButton>
                                        <SelectionPopover />
                                    </Toolbar>
                                </div>
                            </div>
                            <Grid container style={{ position: 'relative' }}>
                                <Hidden smDown>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            height: 30,
                                            width: '35vw',
                                            right: 20,
                                            bottom: 10,
                                            border: '1px solid #ccc',
                                            borderRadius: 10,
                                            padding: '0px 5px'
                                        }}
                                    >
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <p
                                                    style={{
                                                        textAlign: 'center',
                                                        fontSize: 12,
                                                        margin: '5px 0px'
                                                    }}
                                                >
                                                    <strong>Avance de hoja: {pageProgress}%</strong>
                                                </p>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={pageProgress}
                                                    style={{ width: '100%', marginTop: 13 }}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <p
                                                    style={{
                                                        textAlign: 'center',
                                                        fontSize: 12,
                                                        margin: '5px 0px'
                                                    }}
                                                >
                                                    <strong>Avance total: {progress}%</strong>
                                                </p>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={progress}
                                                    style={{ width: '100%', marginTop: 13 }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Hidden>
                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            width: '100%',
                                            height: 'max(450px, calc(100vh - 190px))',
                                            padding: 5
                                        }}
                                    >
                                        {executionReport && executionReport._id ? (
                                            <PautaDetail
                                                filterData={filterData}
                                                height={
                                                    smActivated
                                                        ? 'max(200px, calc(100vh - 850px))'
                                                        : 'max(350px, calc(100vh - 360px))'
                                                }
                                                report={report}
                                                getPautaProgreso={getPautaProgreso}
                                                resultThisItemProgress={resultThisItemProgress}
                                                setUltimoGuardadoDispositivo={
                                                    setUltimoGuardadoDispositivo
                                                }
                                                canEdit={
                                                    canEdit &&
													(isUniversalInspector || isUniversalChief
													    ? userHasStarted
													    : true)
                                                }
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    lineHeight: smActivated
                                                        ? 'max(200px, calc(100vh - 850px))'
                                                        : 'max(350px, calc(100vh - 360px))',
                                                    height: smActivated
                                                        ? 'max(200px, calc(100vh - 850px))'
                                                        : 'max(350px, calc(100vh - 360px))',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        lineHeight: ' 1.5',
                                                        display: 'inline-block',
                                                        verticalAlign: 'middle',
                                                        fontSize: 25
                                                    }}
                                                >
                                                    {messageOnReport}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
            {openPreviewModal && (
                <PreviewDialog
                    open={openPreviewModal}
                    closePreviewModal={closePreviewModal}
                />
            )}
            <PDFFileDialog
                open={openPdfDialog}
                handleClose={() => {
                    setOpenPdfDialog(false)
                    setFileSelected(null)
                }}
                file={fileSelected}
            />
            {openSpmDialog && (
                <SpmDocumentsDialog
                    open={openSpmDialog}
                    handleClose={() => setOpenSpmDialog(false)}
                    spmCode={report?.idPm}
                    guide={report?.guide}
                    readOnly={true}
                />
            )}
            <Modal
                open={open3D}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleModal3D}>
                    <MVAvatar subSistem={subSistem} />
                    <Fab
                        onClick={() => closeModal()}
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            boxShadow: 'none',
                            backgroundColor: 'transparent'
                        }}
                        color="primary"
                    >
                        <Close />
                    </Fab>
                </Box>
            </Modal>
            {openConfirmarBack && isOnline && (
                <ConfirmarDialog
                    open={openConfirmarBack}
                    handleClose={onCancelBackNoEndShift}
                    message="Al salir el reporte queda en ejecución. ¿Desea terminar jornada?"
                    select={onConfirmBackEndShift}
                />
            )}
        </Box>
    )
}

export default ActivitiesDetailPage
